GEAR_OUTLINE